export default class DynatraceScript {
  static getSrcById(id: string) {
    return `https://js-cdn.dynatrace.com/jstag/${id}`
  }
}
